module.exports = __webpack_public_path__ + "img/oie-betalning-nordea.png";